var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "row",
      class: [_vm.question.layout === "vertical" ? "vertical" : "horizontal"],
    },
    [
      _c(
        "div",
        {
          class: [
            _vm.question.layout === "vertical" ? "col-xs-6" : "col-xs-12",
          ],
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "trivia-options",
          class: [
            _vm.question.layout === "vertical" ? "col-xs-6" : "col-xs-12",
          ],
        },
        [
          _vm._l(_vm.question.options, function (option) {
            return _c(
              "div",
              {
                key: option.id,
                staticClass: "card",
                class: { selected: _vm.isSelected(option.id) },
                on: {
                  click: function ($event) {
                    return _vm.selectOption(option.id)
                  },
                },
              },
              [
                _c("p", {
                  staticClass: "trivia-option-text",
                  domProps: { innerHTML: _vm._s(option.text) },
                  on: { click: _vm.handleOptionClick },
                }),
                _vm._v(" "),
                _vm.questionAnswered
                  ? _c(
                      "div",
                      {
                        staticClass: "option-indicator",
                        class: { correct: _vm.isCorrect(option.id) },
                      },
                      [
                        _vm.isCorrect(option.id)
                          ? _c("check", { staticClass: "svg-icon large" })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isCorrect(option.id) && _vm.isSelected(option.id)
                          ? _c("incorrect", { staticClass: "svg-icon large" })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            )
          }),
          _vm._v(" "),
          _vm.multiple && !_vm.questionAnswered
            ? _c("div", { staticClass: "col-xs-12 trivia-submit" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn primary-btn",
                    attrs: { disabled: _vm.selectedOptions.length === 0 },
                    on: { click: _vm.submit },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("CONTINUE")) +
                        "\n            "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }